module.exports = __webpack_public_path__ + "img/menores.8c0b34c0.png";